<template>
  <div class="instructions-panel">
    <div>
      <TheTeamInstructionsAttackingWidth />
    </div>

    <div>
      <TheTeamInstructionsApproachPlay />

      <SelectTeamInstruction
        name="passing"
        :value="passing"
        mutation="updatePassing"
        :options="options.passing"
      >
        {{ $t('tactics.instructions.inPossession.passing.passing') }}
      </SelectTeamInstruction>

      <SelectTeamInstruction
        name="tempo"
        :value="tempo"
        mutation="updateTempo"
        :options="options.tempo"
      >
        {{ $t('tactics.instructions.inPossession.tempo.tempo') }}
      </SelectTeamInstruction>

      <SelectTeamInstruction
        name="time-wasting"
        :value="timeWasting"
        mutation="updateTimeWasting"
        :options="options.timeWasting"
      >
        {{ $t('tactics.instructions.inPossession.timeWasting.timeWasting') }}
      </SelectTeamInstruction>      
    </div>

    <div>
      <TheTeamInstructionsFinalThird />

      <SelectTeamInstruction
        name="vertical-dribbles"
        :value="dribbling"
        mutation="updateDribbling"
        :options="options.dribbling"
      >
        {{ $t('tactics.instructions.inPossession.dribbling.dribbling') }}
      </SelectTeamInstruction>

      <SelectTeamInstruction
        name="movement"
        :value="creativeFreedom"
        mutation="updateCreativeFreedom"
        :options="options.creativeFreedom"
      >
        {{ $t('tactics.instructions.inPossession.creativeFreedom.creativeFreedom') }}
      </SelectTeamInstruction>
    </div>
  </div>
</template>

<script>
import TheTeamInstructionsAttackingWidth from './TheTeamInstructionsAttackingWidth';
import TheTeamInstructionsApproachPlay from './TheTeamInstructionsApproachPlay';
import TheTeamInstructionsFinalThird from './TheTeamInstructionsFinalThird';
import { mapState } from "vuex";
import SelectTeamInstruction from "@/components/SelectTeamInstruction";

export default {
  components: {
    TheTeamInstructionsAttackingWidth,
    TheTeamInstructionsApproachPlay,
    TheTeamInstructionsFinalThird,
    SelectTeamInstruction
  },

  data: () => {
    return {
      options: {
        passing: [
          {value: -2, label: "tactics.instructions.inPossession.passing.muchShorter"},
          {value: -1, label: "tactics.instructions.inPossession.passing.shorter"},
          {value: 0, label: "tactics.instructions.inPossession.passing.standard"},
          {value: 1, label: "tactics.instructions.inPossession.passing.moreDirect"},
          {value: 2, label: "tactics.instructions.inPossession.passing.muchMoreDirect"}
        ],
        tempo: [
          {value: -2, label: "tactics.instructions.inPossession.tempo.muchLower"},
          {value: -1, label: "tactics.instructions.inPossession.tempo.lower"},
          {value: 0, label: "tactics.instructions.inPossession.tempo.standard"},
          {value: 1, label: "tactics.instructions.inPossession.tempo.higher"},
          {value: 2, label: "tactics.instructions.inPossession.tempo.muchHigher"}
        ],
        timeWasting: [
          {value: -2, label: "tactics.instructions.inPossession.timeWasting.frequently"},
          {value: -1, label: "tactics.instructions.inPossession.timeWasting.sometimes"},
          {value: 0, label: "tactics.instructions.inPossession.timeWasting.never"}
        ],
        dribbling: [
          {value: -1, label: "tactics.instructions.inPossession.dribbling.less"},
          {value: 0, label: ""},
          {value: 1, label: "tactics.instructions.inPossession.dribbling.more"}
        ],
        creativeFreedom: [
          {value: -1, label: "tactics.instructions.inPossession.creativeFreedom.less"},
          {value: 0, label: ""},
          {value: 1, label: "tactics.instructions.inPossession.creativeFreedom.more"}
        ]
      }
    };
  },

  computed: mapState({
    passing: state => state.instructions.inPossession.passing,
    tempo: state => state.instructions.inPossession.tempo,
    timeWasting: state => state.instructions.inPossession.timeWasting,
    dribbling: state => state.instructions.inPossession.dribbling,
    creativeFreedom: state => state.instructions.inPossession.creativeFreedom
  })
}
</script>

<style scoped>

</style>
